import { render, staticRenderFns } from "./EventRecords.vue?vue&type=template&id=deb323e6&scoped=true"
import script from "./EventRecords.vue?vue&type=script&lang=ts"
export * from "./EventRecords.vue?vue&type=script&lang=ts"
import style0 from "./EventRecords.vue?vue&type=style&index=0&id=deb323e6&prod&scoped=true&lang=scss"
import style1 from "./EventRecords.vue?vue&type=style&index=1&id=deb323e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb323e6",
  null
  
)

export default component.exports